<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>{{tituloCrud}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioDeUsuario" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-9 col-md-9 col-sm-8 col-12">
                            <mat-label>Nome</mat-label>
                            <input matInput value="Nome" class="form-control" id="name" required trim="blur" name="name"
                                formControlName="name" maxlength="60" upperCase>
                            <mat-error *ngIf="formularioDeUsuario.controls.name.hasError('required')">
                                O campo Nome é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioDeUsuario.controls.name.hasError('minlength')">
                                O campo Nome precisa conter mais do que 5 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field floatPlaceholder="always" class="form-group col-lg-3 col-md-3 col-sm-4 col-12"
                            style="padding-top: 2px;">
                            <input matInput style="display: none">
                            <mat-checkbox id="enabled" formControlName="enabled">Disponível</mat-checkbox>
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Login</mat-label>
                            <input matInput value="Login" class="form-control" id="username" trim="blur" name="username"
                                formControlName="username" maxlength="30" required>
                            <mat-error *ngIf="formularioDeUsuario.controls.username.hasError('required')">
                                O campo Login é obrigatório.
                            </mat-error>
                            <mat-error *ngIf="formularioDeUsuario.controls.username.hasError('minlength')">
                                O campo Login precisa conter mais do que 2 caracteres.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Perfil</mat-label>
                            <mat-select value="Perfil" formControlName="perfil" name="perfil" id="perfil" required>
                                <mat-option *ngFor="let perfil of listaPerfis" [value]="perfil">
                                    {{perfil}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formularioDeUsuario.controls.perfil.hasError('required')">
                                O campo Perfil é obrigatório.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-row" *ngIf="!isInfo">
                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Senha</mat-label>
                            <input matInput type="password" value="Senha" class="form-control" id="password" trim="blur"
                                name="password" formControlName="password" maxlength="20">
                            <mat-error *ngIf="formularioDeUsuario.controls.password.hasError('required')">
                                O campo Senha é obrigatório.
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                            <mat-label>Confirmar Senha</mat-label>
                            <input matInput type="password" value="Confirmar Senha" class="form-control"
                                id="confirmPassword" trim="blur" name="confirmPassword"
                                formControlName="confirmPassword" maxlength="20">
                            <mat-error *ngIf="formularioDeUsuario.controls.confirmPassword.hasError('required')">
                                O campo Confirmar Senha é obrigatório.
                            </mat-error>
                            <mat-error
                                *ngIf="formularioDeUsuario.controls.confirmPassword.hasError('confirmedValidator')">
                                Os campos Senha e Confirmar Senha precisam ser iguais.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes margin-right-10" *ngIf="!isInfo">
                            <button mat-mini-fab color="success" type="submit" matTooltip="Salvar"
                                [disabled]="!formularioDeUsuario.valid">
                                <mat-icon>save</mat-icon>
                            </button>
                        </div>
                        <div class="menu-formulario-botoes">
                            <botao-voltar></botao-voltar>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>